import React, { useState, useEffect, Fragment } from "react";
import ModelPopup from "../../helpers/ModelPopup";
import { useSelector } from "react-redux";
import Input from "react-validation/build/input";
import BoLoader from "../../helpers/BoLoader";
import Form from "react-validation/build/form";
import crossimg from "../../assets/images/icons/cross.svg";
import DialoguePopup from "../../helpers/DialoguePopup";
import IssueBulkCardService from "../../services/cards.services";
import download from 'downloadjs';
import file from '../../middlewareTemp/SampleDebit.csv'
import SearchGridRejectedData from "./SearchGridRejectedData";
import ExportToExcel from "../superadmin/ExportToExcel";
import GetAllSubClients from "../superclient/GetAllSubClients";
import IsEmptyObj from "../../helpers/IsEmpty";


const BulkDebitCard = props => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [ShowClietErr, setShowClientErr] = useState("d-none");
  const [isSuperClient, setIsSuperClient] = useState(false);
  const [RejectedData, setRejectedData] = useState();
  const [modalShowRejectedData, setModalShowRejectedData] = useState();
  const [boloader, setBoLoader] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modelhdng, setMdlHdng] = useState("");
  const [modelbdy, setMdlBdy] = useState("");
  const [MdlIcon, setMdlIcon] = useState("");
  const [ClientId, setClientId] = useState(currentUser?.user?.ClientId ?? 0);

  const [fileSize, setFileSize] = useState();
  const [isValidFile, setisValidFile] = useState(true);
  const [fileName, setFileName] = useState("");
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (currentUser?.user?.SuperClientId > 0)
      setIsSuperClient(true);
  }, []);

  const errorAndSuccessModl = (heading, body, errIcon) => {
    setModalShow(true);
    setMdlHdng(heading);
    setMdlBdy(body);
    setMdlIcon(errIcon);
  };

  const requiredClient = value => {
    if (!value) {
      document.getElementById("id_client")?.classList.add("has_error");
      setShowClientErr("");
      return false;
    } else {
      document.getElementById("id_client")?.classList.remove("has_error");
      setShowClientErr("d-none");
      return true;
    }
  };

  const ClientNameChangeHandlers = async e => {
    const clientName = e.target.selectedOptions[0].value;
    if (!IsEmptyObj.IsEmpty(clientName)) {
      let val = parseInt(clientName);
      setClientId(val);
      requiredClient(val);
    } else {
      setClientId(0);
      requiredClient(0);
    }
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const onSubmitBulkIssueCard = e => {
    if (isSuperClient && (!ClientId || ClientId === 0)) {
      requiredClient(0);
      let msgBody = "Please Select The Program";
      let errIcon = "icon-error";
      errorAndSuccessModl("Error", msgBody, errIcon);
      e.target.value = null;
      return;
    }

    const file_data = e.target.files[0];
    if (!file_data) return;

    const formdata = new FormData();
    let reg = /(.*?)\.(csv|xml)$/;
    if (!file_data.name.match(reg)) {
      setisValidFile(false);
      return false;
    }
    setisValidFile(true);
    setFileName(file_data.name);
    setFileSize(formatBytes(file_data.size));
    formdata.append("File", file_data);

    let clientid = isSuperClient
      ? Number(ClientId)
      : parseInt(currentUser?.user?.ClientId);

    setBoLoader(true);
    IssueBulkCardService
      .BulkDebitCard(formdata, null, clientid)
      .then(response => {
        setBoLoader(false);
        const result = response?.data?.result;
        const item1 = result?.item1;
        const item2 = result?.item2;

        if (item2?.length > 0) {
          setRejectedData(item2);
          setModalShowRejectedData(true);
        }
        else if (item1 && item1 !== "Success") {
          errorAndSuccessModl("Error", item1, "icon-error");
        }
        else if (item2?.length === 0) {
          errorAndSuccessModl("Success", "Data Saved Successfully", "icon-success");
        }
      })
      .catch(error => {
        setBoLoader(false);
        const data = error?.response?.data;
        let msgBody =
          (typeof data === "string" && data) ||
          data?.message ||
          data?.title ||
          error?.message ||
          "Something Went Wrong";
        errorAndSuccessModl("Error", msgBody, "icon-error");
      });
  };

  const uploadFileAddClient = () => {
    document.getElementById("AddClientFileUpload").click();
  };

  const onCrossImg = () => {
    setFileName("");
    setisValidFile(true);
  };

  const downloadSampleFile = async () => {
    try {
      setErrorMsg('');
      return download(file);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setErrorMsg('Error while downloading file. Try again later');
      }
    }
  };

  const onShowModelClearFields = () => {
    setFileName("");
    setisValidFile(true);
    setClientId(currentUser?.user?.ClientId ?? 0);
    setShowClientErr("d-none");
    if (props.calledfrom !== "cardholderdetails") {
      props.onHide();
    }
  };

  const renderBulkDebitCard = () => (
    <Form className="search-form" onSubmit={(e) => e.preventDefault()}>
      <div className="files-container mb-40">
        {errorMsg && <p className="errorMsg">{errorMsg}</p>}
        <tr>
          <td>
            <a
              onClick={downloadSampleFile}
              style={{ textAlign: "center", color: "blueviolet", font: "message-box", cursor: "grab" }}
            >
              <b>Click Here to Download Sample CSV File.</b>
            </a>
          </td>
        </tr>
      </div>

      {isSuperClient && (
        <div className="col-md-12" id="id_client">
          <div className="form-group">
            <label>Select Program*</label>
            <div className="form-controls">
              <GetAllSubClients
                clientnamechangehandler={ClientNameChangeHandlers}
                searchgriddata="Y"
              />
              <span className={"help-block " + ShowClietErr}>
                Client is required!
              </span>
            </div>
          </div>
        </div>
      )}

      {fileName === "" ? (
        <div className="col-md-6 ">
          <div className="form-group">
            <label>Attach CSV File</label>
            <div className="form-controls">
              <div>
                <Input
                  type="file"
                  hidden
                  id="AddClientFileUpload"
                  className="form-control"
                  accept=".csv,.xml,.json"
                  name="logo"
                  onChange={onSubmitBulkIssueCard}
                />
                <h5
                  className="form-control file-control"
                  onClick={uploadFileAddClient}
                >
                  <label>Drag files here to upload or </label> Browse file
                </h5>
                {!isValidFile && (
                  <span className="help-block has_error">
                    Invalid file format
                  </span>
                )}
              </div>
              <span className="icon-upload-file _ico">
                <span className="path1"></span>
                <span className="path2"></span>
              </span>
            </div>
            <span className="fs-12 clr-submarine mt-2 d-block">
              Supported file types XML/CSV file.
            </span>
          </div>
        </div>
      ) : (
        <div className="col-md-6">
          <div className="form-group">
            <div className="bo-file d-flex">
              <div className="file-name">
                <span className="icon-upload-file _ico">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </span>
                <h5>
                  <span>{fileName}</span>
                </h5>
              </div>
              <div className="ml-auto file-size" onClick={onCrossImg}>
                <span>{fileSize}</span>
                <img
                  className="cross-icon"
                  src={crossimg}
                  onClick={onCrossImg}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Form>
  );

  return (
    <Fragment>
      <BoLoader loading={boloader} />
      <DialoguePopup
        show={modalShow}
        onHide={() => setModalShow(false)}
        hideallpopups={() => setModalShow(false)}
        modelheading={modelhdng}
        modelbody={modelbdy}
        modelicon={MdlIcon}
      />
      <ModelPopup
        key={21}
        show={props.show}
        onHide={() => onShowModelClearFields()}
        modelheading={""}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-76"
        backdrop="static"
        keyboard={false}
        modelbody={renderBulkDebitCard()}
      />
      <ModelPopup
        show={modalShowRejectedData}
        key={22}
        onHide={() => { setModalShowRejectedData(false) }}
        modelheading={""}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-86"
        modelbody={[
          <Fragment>
            <div className="nav-item ms-auto" role="presentation">
              <ExportToExcel
                Dataset={RejectedData}
                Name="BulkDebit"
                calledfrom="bulkdebit"
              />
            </div>
            <SearchGridRejectedData
              methodname="notes"
              placeholdervalue="Search"
              headersdata={[
                "AMOUNT",
                "TOKEN ID",
                "ERROR MESSAGE",
              ]}
              screenname="bulkdebit"
              calledfrom="bulkdebit"
              data={RejectedData}
            />
          </Fragment>,
        ]}
      />
    </Fragment>
  );
};

export default BulkDebitCard;
